export const TimeKeepingVI = {
    "timekeepingSettings": "Cài đặt chấm công",
    "timesheetFormula": "Công thức chấm công",
    "shiftWork": "Cài đặt ca làm việc",
    "annualLeave": "Cài đặt nghỉ phép",
    "setupHoliday": "Cài đặt nghỉ lễ",
}